(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
    document.querySelector('.img__btn').addEventListener('click', function() {
    document.querySelector('.cont').classList.toggle('s--signup');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var formStatus = document.getElementById("form-status-container");
  
  if (formStatus && formStatus.innerHTML.trim() !== "") {
    var mainContainer = document.querySelector(".page-wishlist .container");
    
    if (mainContainer) {
      mainContainer.insertAdjacentHTML("afterbegin", formStatus.innerHTML);
      formStatus.innerHTML = ""; // Clear the modal message to avoid duplication
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
